import { createRouter, createWebHistory } from 'vue-router';
import App from '@/App.vue';

const routes = [
  {
    path: '/:slug?/:subSlug?',
    name: 'Main',
    component: App,
    props: true, // passes the slug param as a prop if needed
  },
];

const router = createRouter({
  base: process.env.BASE_URL,
  history: createWebHistory('/'),
  routes,
});

export default router;